<template>
  <div class="filedsContainer">
    <div class="head">
      <div class="title">{{ shopName }}</div>
      <div class="font-tip">
        <span>企业类型：{{ shopTypeName }}</span>
        <MyTypes v-if="this.status != null" :type="String(this.status)" />
        <span
          v-if="riskCount !== null && riskCount && riskCount > 0"
          @click="showRiskDetail"
        >
          <span style="margin: 0px 10px">风险校验</span>
          <el-tag type="success" size="mini" v-if="riskCount === 0"
            >正常</el-tag
          >
          <el-tag type="danger" size="mini" v-if="riskCount && riskCount > 0"
            >{{ riskCount }}项异常</el-tag
          >
        </span>
      </div>
    </div>
    <div class="body">
      <InfoDetail
        ref="InfoDetail"
        :infoDetailData="infoDetailData"
        :disabled="disabled"
        :type="type"
        :queryScopeListData="queryScopeListData"
      />
    </div>
    <div class="footer" v-if="disabled && type == 'approve'">
      <el-button size="mini" @click="back">返回上一页</el-button>
      <ConfirmDialog
        ref="ConfirmDialog"
        style="margin: 0 10px"
        @confirm="confirm"
      >
        <el-button type="primary" size="mini" @click="openConfirm"
          >审核通过</el-button
        >
      </ConfirmDialog>
      <RejectDialog ref="RejectDialog" style="margin: 0 10px" @confirm="reject">
        <el-button type="primary" size="mini" @click="openReject">
          驳回
        </el-button>
      </RejectDialog>
      <el-button type="primary" size="mini" v-if="status == '0'" @click="edit"
        >编辑</el-button
      >
    </div>
    <div class="footer" v-if="!disabled && type == 'approve'">
      <el-button size="mini" @click="back">返回上一页</el-button>
      <el-button type="primary" size="mini" @click="back">取消编辑</el-button>
      <el-button type="primary" size="mini" @click="save">确认调整</el-button>
    </div>
    <div class="footer" v-if="type == 'view' || type == 'viewNoEdit'">
      <el-button size="mini" @click="back">返回上一页</el-button>
      <el-button
        type="primary"
        size="mini"
        v-if="type == 'view' && status == '2'"
        @click="edit"
        >编辑</el-button
      >
    </div>
    <div class="footer" v-if="type == 'edit'">
      <el-button size="mini" @click="back">返回上一页</el-button>
      <el-button type="primary" size="mini" @click="back">取消编辑</el-button>
      <el-button type="primary" size="mini" @click="save">确认调整</el-button>
    </div>
    <ShopRiskDlg ref="shopRiskDlgRef"></ShopRiskDlg>
  </div>
</template>
<script>
import InfoDetail from "./children/infoDetail.vue";
import RejectDialog from "../components/rejectDialog.vue";
import ConfirmDialog from "../components/confirmDialog.vue";
import ShopRiskDlg from "./components/shopRiskDlg.vue";
import {
  getCertificationByRequestId,
  queryScopeList,
  compShopCertifyCommit,
  auditCompanyEdit,
  getApproveDetail,
  getTempDataInfo,
  getShopRiskDetail,
} from "@/api/qualification/qualification";
import MyTypes from "@/components/myTypes";

export default {
  name: "QAuditDetail",
  components: { InfoDetail, RejectDialog, ConfirmDialog, MyTypes, ShopRiskDlg },
  // watch: {
  //   modeValue: {
  //     immediate: true,
  //     handler: function (value) {
  //       console.log(value, "value");
  //     },
  //   },
  // },
  data() {
    return {
      type: "approve", // view
      status: null,
      roleId: null,
      relationType: null,
      shopTypeName: null,
      shopName: null,
      orgCode: null,
      deptId: null,
      disabled: true,
      remarks: "",
      infoDetailData: {},
      queryScopeListData: [],
      riskCount: 0, //风险项数量
      riskList: [], //风险项列表
    };
  },
  methods: {
    showRiskDetail() {
      this.$refs.shopRiskDlgRef.publicOpen(this.riskList, this.infoDetailData);
    },
    back() {
      this.$router.go(-1);
    },
    openReject() {
      this.$refs.RejectDialog.openDialog();
    },
    openConfirm() {
      this.$refs.ConfirmDialog.openDialog();
    },
    getNextStatus(status) {
      switch (status) {
        case "0":
          return "20";
        case "20":
          return "2";
        case "1":
          return "0";
      }
    },
    confirm() {
      const formData = this.$refs.InfoDetail.getFormData();
      if (formData) {
        const params = {
          relationType: this.relationType,
          shopId: this.shopId,
          deptId: this.deptId,
          orgCode: this.orgCode,
          roleId: this.roleId,
          status: this.getNextStatus(this.status),
          // remarks: this.remarks,
          certifyList: formData.gridList.map((filed) => {
            return {
              typeCode: filed.certityType,
              certityType: filed.certityType,
              code: filed.certityType,
              termType: filed.termType,
              startValidDate: filed.periodValidity[0],
              endValidDate: filed.periodValidity[1],
            };
          }),
          scopeIds: String(formData.checkList),
        };
        auditCompanyEdit(params).then((res) => {
          this.$message.success("审核通过");
          this.$refs.ConfirmDialog.closeDialog();
          this.back();
        });
      } else {
        this.$message.warning("请输入必填项");
      }
    },
    reject(list, text) {
      if (list && list.length > 0) {
        if (!text || text == "undefined") {
          text = "";
        } else {
          text = "," + text;
        }
        const params = {
          shopId: this.shopId,
          status: 1,
          remarks: String(list) + text,
        };
        auditCompanyEdit(params).then((res) => {
          this.$message.success("驳回成功");
          this.$refs.RejectDialog.closeDialog();
          this.back();
        });
      }
    },
    edit() {
      this.disabled = !this.disabled;
      if (this.status == "2") {
        this.type = "edit";
      }
    },
    save() {
      const formData = this.$refs.InfoDetail.getFormData();
      if (formData) {
        const params = {
          requestId: this.infoDetailData.requestId,
          scopeIds: String(formData.checkList),
          shopTypeCode: this.infoDetailData.shopTypeCode,
          certifyList: formData.gridList.map((filed) => {
            return {
              certificateId: filed.certificateId,
              certificateName: filed.certificateName,
              certityType: filed.certityType,
              certificateImages: filed.imageUrlList,
              example: filed?.example,
              template: filed?.template,
              typeCode: filed?.certityType,
              code: filed.certityType,
              termType: filed?.termType,
              startValidDate: filed?.periodValidity[1]
                ? filed?.periodValidity[0]
                : "",
              endValidDate: filed?.periodValidity[1] || "",
              fields: filed.filedList
                ? filed.filedList.map((f) => {
                    return {
                      fieldNameText: f.tip,
                      fieldName: f.fieldName,
                      fieldValue: f.modeValue ? String(f.modeValue) : "",
                      certificateId: f.certificateId,
                      inputType: f.type,
                      required: f.isMust ? 1 : 0,
                    };
                  })
                : [],
            };
          }),
          commonFieldList: formData.filedList
            ? formData.filedList.map((field) => {
                return {
                  fieldNameText: field.field,
                  fieldName: field.fieldName,
                  fieldValue: field.modeValue ? String(field.modeValue) : "",
                  certificateId: field.certificateId,
                  inputType: field.type,
                  required: field.isMust ? 1 : 0,
                };
              })
            : [],
        };
        compShopCertifyCommit(params).then((res) => {
          this.$message.success("编辑成功");
          this.disabled = true;
          if (this.status == "2") {
            this.type = "view";
          }
          this.getDetail(this.infoDetailData.requestId);
          // this.back(); //push to where?
        });
      } else {
        this.$message.warning("请输入必填项");
      }
    },
    getShopRiskDetailByShopId() {
      getShopRiskDetail({ shopId: this.shopId }).then((res) => {
        if (res && res.length > 0) {
          this.riskList = res;
        }
      });
    },
    getDetail(requestId) {
      getCertificationByRequestId(requestId).then((res) => {
        // this.relationType = res.data.shopTypeCode;
        this.infoDetailData = res.data;
        this.status = res.data.status;
        if (res.data.riskCount && res.data.riskCount > 0) {
          this.riskCount = res.data.riskCount;
          this.getShopRiskDetailByShopId();
        }
      });
    },
  },
  mounted() {
    // 查经营范围
    const {
      type,
      shopId,
      status,
      roleId,
      relationType,
      orgCode,
      deptId,
      shopName,
      shopTypeName,
      requestId,
      pageType,
    } = this.$route.query;
    this.type = type;
    // this.status = status || 0;
    this.roleId = roleId;
    this.shopId = shopId;
    this.relationType = relationType;
    this.orgCode = orgCode;
    this.deptId = deptId;
    this.shopTypeName = shopTypeName;
    this.shopName = shopName;

    queryScopeList().then((res) => {
      this.queryScopeListData = res.data || [];
    });
    if (this.type == "edit") {
      this.disabled = false;
    }
    if (requestId) {
      //  获取详情
      this.getDetail(requestId);
    } else if (this.type == "view") {
      if (!status && pageType != "history") {
        getTempDataInfo(this.shopId).then((res) => {
          this.infoDetailData = res.data;
          this.status = null;
        });
      } else {
        getApproveDetail(this.shopId).then((res) => {
          // this.relationType = res.data.shopTypeCode;
          this.infoDetailData = res.data;
          this.status = null;
        });
      }
    } else {
      return;
    }
  },
};
</script>
<style lang="scss" scoped>
.filedsContainer {
  display: flex;
  flex-flow: column;
  height: 100%;
  overflow-y: auto;
  .head {
    background: #ffffff;
    height: 76px;
    padding: 10px;
    line-height: 28px;
    border-radius: 4px;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      padding-left: 20px;
    }
  }
  .font-tip {
    padding-left: 20px;
    font-size: 14px;
    color: #595959;
  }
  .body {
    background: #ffffff;
    padding: 10px;
    margin-top: 10px;
    display: flex;
    flex: 1;
    overflow-y: auto;
    border-radius: 4px;
  }
  .footer {
    padding: 20px;
    background: #ffffff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
</style>
